import { useProperty, useTranslation } from '@eti/providers';
import { vars } from '@etg/wings';
import { css } from '@eti/styles';
import { Check } from '@phosphor-icons/react';
import MainUniqueSellingPoint from '../../../../common/components/MainUniqueSellingPoint';
import UniqueSellingPointWrapper from '../../../../common/components/UniqueSellingPointWrapper';
import UniqueSellingPoint from '../../../../common/components/UniqueSellingPoint';

interface SellingPointProps {
  shouldDisplayMainUsp: boolean;
}

const sellingPointsStyles = css`
  border-top: 1px solid ${vars.colors.divider};
  margin-top: auto;
`;

const CheckSize20 = () => {
  return <Check size={20} />;
};

export const SellingPoint = ({ shouldDisplayMainUsp }: SellingPointProps) => {
  const { p } = useProperty();
  const { t } = useTranslation();

  const isUspEnabled = p('IbeClient.USP.Enabled');

  if (!isUspEnabled) {
    return null;
  }

  return (
    <>
      {shouldDisplayMainUsp && <MainUniqueSellingPoint className={sellingPointsStyles} />}
      {!shouldDisplayMainUsp && (
        <UniqueSellingPointWrapper
          className={sellingPointsStyles}
          dataTestId="your-selected-trip-page-usp-footer"
        >
          <UniqueSellingPoint icon={<CheckSize20 />} label={t('YourSelectedTrip.USPOne.Label')} />
          <UniqueSellingPoint icon={<CheckSize20 />} label={t('YourSelectedTrip.USPTwo.Label')} />
          <UniqueSellingPoint icon={<CheckSize20 />} label={t('YourSelectedTrip.USPThree.Label')} />
        </UniqueSellingPointWrapper>
      )}
    </>
  );
};
